<app-header headerText="Parámetros Caja De Ahorro Permanente"></app-header>

<mat-tab-group *ngIf="modParameter" mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true [selectedIndex]="selectedIndex" (selectedTabChange)="tabChanged($event)">

  <mat-tab [disabled]='isEdit'>

    <ng-template mat-tab-label>
      <mat-icon>add</mat-icon>
      Crear Nuevo<br>Ciclo
    </ng-template>

    <div class="row py-2 border-bottom">

      <div class="col-md-4 offset-md-4">
        <mat-form-field>
          <input matInput placeholder="Nombre Del Nuevo Ciclo:" [(ngModel)]="modParameter.title" type="text"
            #name="ngModel" id="name" (keyup)="keyUpMethod($event.target.value)" required>
          <mat-error *ngIf="name.invalid && name?.errors.required">El Nombre del Ciclo es Requerido</mat-error>
        </mat-form-field>
      </div>

    </div>

    <app-ps-parameters [modParameter]="modParameter" [ngClass]="{'blocked': !isNew}" [contentLocation]="contentLocation"></app-ps-parameters>

    <div class="row px-3 my-4" [ngClass]="{'blocked': !isNew}">

      <div class="col-md-4 offset-md-4">
        <button class="btn btn-block btn-outline-secondary" (click)="cancelPeriodChanges();" >Cancelar</button>
      </div>

      <div class="col-md-4">
        <button class="btn btn-block btn-primary" (click)="savePeriod()">Guardar Cambios</button>
      </div>

    </div>

  </mat-tab>

  <mat-tab [disabled]='isNew'>

    <ng-template mat-tab-label>
      <mat-icon>edit</mat-icon>
      Editar<br>Ciclo
    </ng-template>

    <div class="row py-2 border-bottom">

      <div class="col-md-4 offset-md-4">

        <mat-form-field>
          <mat-select placeholder="Nombre del Ciclo de Ahorro a Editar:" (selectionChange)="selectedPeriodChange($event)" [value]="tempPeriod">
            <mat-option>Seleccione el ciclo</mat-option>
            <mat-option *ngFor="let period of savingParameters" [value]="period">
              {{period.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

    </div>

    <app-ps-parameters [modParameter]="modParameter" [ngClass]="{'blocked': !isEdit}" [contentLocation]="contentLocation" (hideActionButtons)="hideActionButtons($event)"></app-ps-parameters>
 
    <div class="row px-3 my-4" [ngClass]="{'blocked': !isEdit}" [hidden]="hideActions">

      <div class="col-md-4 offset-md-4">
        <button class="btn btn-block btn-outline-secondary" (click)="cancelPeriodChanges();" >Cancelar</button>
      </div>

      <div class="col-md-4">
        <button class="btn btn-block btn-primary" (click)="savePeriod()">Guardar Cambios</button>
      </div>

    </div>

  </mat-tab>

</mat-tab-group>
